import { SwapRightOutlined } from '@ant-design/icons';
import { DefaultOptionType } from '@bugly/common';
import { useControllableValue } from 'ahooks';
import classnames from 'classnames';
import React from 'react';
import { CustomAutoComplete } from '@/presentation/components/form/components/auto-complete';
import { StandardFormType } from '@/presentation/components/form/standards/types';
import styles from './index.module.scss';

export interface CharacterRangePickerProps extends StandardFormType{
  rangeOptions?: DefaultOptionType[];
  dropDownWidth?: number;
}

export const CharacterRangePicker = (props: CharacterRangePickerProps) => {
  const { rangeOptions = [], dropDownWidth } = props;
  const [value, setValue] = useControllableValue(props);

  return (
    <div className={styles.rangePicker}>
      <CustomAutoComplete
        name={'appVersion'}
        value={value?.[0]}
        options={rangeOptions}
        dropdownMatchSelectWidth={dropDownWidth}
        onChange={(val) => {
          setValue([
            val,
            value?.[1],
          ]);
        }}
        className={classnames(styles.rangeLeft, 'query-form-auto-complte')}
      />
      <SwapRightOutlined className={styles.outlined}/>
      <CustomAutoComplete
        name={'appVersion'}
        value={value?.[1]}
        options={rangeOptions}
        dropdownMatchSelectWidth={dropDownWidth}
        className={classnames(styles.rangeRight, 'query-form-auto-complte')}
        onChange={(val) => {
          setValue([
            value?.[0],
            val,
          ]);
        }}
      />
    </div>
  );
};
